import { Exception } from './exception';

export class RundeckException extends Exception {}
